import { useState } from "react";
import { Popover, Stack, TextField } from "@shopify/polaris";
import { SketchPicker } from "react-color";

function ColorIndicator({ id, color, ...props }) {
  return (
    <div
      style={{
        width: "35px",
        height: "36px",
        border: "1px solid rgb(201 204 207)",
        borderRadius: "5px",
        fontWeight: 500,
        background: color,
      }}
      onClick={() => {
        props.handleClick(id);
      }}
    ></div>
  );
}

function LoopColorPicker({ id, color, ...props }) {
  const [popover, setpopover] = useState(false);

  let activator = (
    <ColorIndicator
      color={color}
      id={id}
      handleClick={(val) => {
        setpopover(id);
      }}
    />
  );

  return (
    <Popover
      active={popover === id}
      activator={activator}
      ariaHaspopup={false}
      onClose={() => {
        setpopover(null);
      }}
    >
      <SketchPicker
        color={color}
        onChangeComplete={(val) => {
          props.changeColor(val.hex);
        }}
      />
    </Popover>
  );
}

export function LoopColorPickerInput({
  id,
  color,
  label,
  disabled,
  onChange,
  ...props
}) {
  return (
    <Stack vertical={true} spacing="tight">
      <Stack.Item>{label}</Stack.Item>
      <Stack.Item>
        <Stack alignment="trailing" spacing="extraTight">
          <LoopColorPicker
            id={id}
            color={color}
            changeColor={(val) => {
              onChange(val);
            }}
          />
          <div style={{ width: "90px", fontWeight: 500 }}>
            <TextField
              disabled={disabled}
              value={color}
              onChange={(val) => {
                onChange(val);
              }}
              autoComplete="off"
              align="right"
            />
          </div>
        </Stack>
      </Stack.Item>
    </Stack>
  );
}

export default LoopColorPicker;
